import React, { useEffect, useRef, useState } from "react";
import { gsap } from "gsap";
import "./banner.scss";
import lottie from "lottie-web";
import { Link } from "react-router-dom";
const Mobilebanner = () => {
  const headRef = useRef(null);
  const paraRef = useRef(null);
  const buttonRef = useRef(null);
  const textRef = useRef(null);
  const leftIconRef = useRef(null);
  const rightIconRef = useRef(null);
  const bgRef = useRef(null);
  const iconsRef = useRef(null);
  const bannerRef = useRef(null);
  const leftCardRef = useRef(null);
  const rightCardRef = useRef(null);
  const videoCardRef = useRef(null);
  const innerBannerRef = useRef(null);
  const [viewportHeight, setViewportHeight] = useState(window.innerHeight);
  const updateStyles = () => {
    const vh = window.innerHeight;
    setViewportHeight(vh);

    if (bannerRef.current) {
      bannerRef.current.style.marginTop = `${vh * 0.5}px`; // 30vh
      bannerRef.current.style.paddingTop = `${vh * 0.1}px`; // 13.472vw
    }
  };
  useEffect(() => {
    const banner = innerBannerRef.current;

    gsap.to(banner, {
      opacity: 0,
      pointerEvents: 'none',
      scale: 0.9,
      height: 0,
      ease: "power2.out",
      scrollTrigger: {
        trigger: banner,
        start: "top 20%",
        end: "bottom 80%",
        scrub: true,
      },
    });
  }, []);

  useEffect(() => {
    let ctx = gsap.context(() => {
      let tl = gsap.timeline({
        scrollTrigger: {
          trigger: bannerRef.current,
          start: "top+=0px top",
          end: "+=3000px",
          scrub: true,
          pin: true,
          anticipatePin: 1,
          toggleActions: "play none none reset",
        },
      });
      tl.fromTo(
        videoCardRef.current,
        { y: 350 },
        { y: 0, duration: 10, ease: "power2.out" }
      );
      tl.to({}, { duration: 0.5 });

      // Animate first lower card appearing
      tl.fromTo(
        ".lowercard.mblorder-2",
        {
          height: "175px",
          duration: 10,
          y: 350,
          opacity: 0,
        },
        {
          height: "175px",
          duration: 10,
          y: 0,
          opacity: 1,
          position: "absolute",
        }
      );

      // Animate second lower card like the first
      tl.fromTo(
        ".lowercard.mblorder-3",
        {
          height: "175px",
          duration: 10,
          y: 350,
          opacity: 0,
        },
        {
          height: "175px",
          duration: 10,
          y: 0,
          opacity: 1,
        }
      );

      // Show second video over first video
      tl.fromTo(
        ".bannervideo video:last-child",
        { opacity: 0 },
        { opacity: 1, duration: 10, ease: "power2.out" }
      );
    });

    return () => ctx.revert(); // Cleanup GSAP animations
  }, []);
  const container1 = useRef(null);
  const container2 = useRef(null);

  useEffect(() => {
    const animation1 = lottie.loadAnimation({
      container: container1.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      path: "/assets/comment.json", // Replace with your JSON file path
    });

    const animation2 = lottie.loadAnimation({
      container: container2.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      path: "/assets/wallet.json",
    });

    return () => {
      animation1.destroy();
      animation2.destroy();
    };
  }, []);


  useEffect(() => {
    const button = buttonRef.current;
    const text = textRef.current;
    const leftIcon = leftIconRef.current;
    const rightIcon = rightIconRef.current;
    const icons = iconsRef.current;

    gsap.fromTo(
      button,
      { scaleX: 0, opacity: 0, width: 0, },
      { scaleX: 1, opacity: 1, duration: 0.6, ease: "power2.out", delay: 0.4, width: '243px' }
    );

    gsap.fromTo(
      [text, leftIcon],
      { y: 20, opacity: 0, },
      {
        y: 0,
        opacity: 1,
        duration: 0.5,
        ease: "power2.out",
        delay: 1,
        stagger: 0.1,
      }
    );
  }, []);

  useEffect(() => {
    const tl = gsap.timeline();

    gsap.set(headRef.current, {
      clipPath: "inset(0% 100% 0% 0%)",
      opacity: 1,
    });

    tl.to(headRef.current, {
      clipPath: "inset(0% 0% 0% 0%)",
      duration: 1,
      ease: "power2.out",
    });
  }, []);

  useEffect(() => {
    const tl = gsap.timeline();

    tl.from(
      paraRef.current,
      {
        y: 30,
        opacity: 0,
        duration: 0.8,
        ease: "power2.out",
      },
    ); // Slightly earlier
  }, []);

  const [isHidden, setIsHidden] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsHidden(true);
      } else {
        setIsHidden(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <section className="main-banner d-block-for-mobile d-none">
      <img
        src="/assets/roadmapassets/banner/topbg.png"
        alt="mainbannertopbg"
        className="mainbannertopbg"
      />
      <img
        src="/assets/roadmapassets/banner/topbgmbl.png"
        alt="mainbannertopbg"
        className="mainbannertopbgmbl d-none"
      />
      <img
        src="/assets/roadmapassets/banner/bannershade.png"
        alt="bannershade"
        className="bannershade"
      />
      <img
        src="/assets/roadmapassets/banner/bannershadembl.png"
        alt="bannershade"
        className="bannershadembl d-none"
      />
      <div className="innerbanner" style={{zIndex : isHidden ? '0': '800'}} ref={innerBannerRef}>
        <div className="d-flex justify-content-start align-items-start">
          <h1 ref={headRef} className="innerbannerhead">Where <br /> Money Chats</h1>
        </div>

        <p ref={paraRef} className="innerbannerpara">
          Be among the first to experience TOMI’s chat and wallet app – sign up
          now for early access and an exclusive airdrop!
        </p>
        <div className="button-wrapper"  data-bs-toggle="modal"
            data-bs-target="#exampleModal">
          <button
          ref={buttonRef}
           
            className="animated-btn"
          >
            <span  ref={leftIconRef} className="icon iconone">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="16"
                viewBox="0 0 15 16"
                fill="none"
              >
                <path
                  d="M7.49946 0.828125C3.53838 0.828125 0.327637 4.03886 0.327637 7.99995C0.327637 9.665 0.895043 11.198 1.84692 12.415C1.92714 12.5177 2.0729 12.5402 2.18345 12.4707L3.77512 11.4699C3.79175 11.4592 3.80643 11.4474 3.82012 11.4337L6.10932 9.99957V14.8225C6.10932 14.9468 6.19736 15.0554 6.32063 15.0749C6.70411 15.1385 7.09739 15.1718 7.49946 15.1718C7.90154 15.1718 8.32612 15.1366 8.72428 15.0671C8.84656 15.0456 8.93363 14.9389 8.93363 14.8147V10.027L11.2072 11.4513C11.214 11.4562 11.2199 11.4621 11.2267 11.467L12.8213 12.4629C12.9319 12.5324 13.0767 12.5089 13.1569 12.4062C13.603 11.8348 13.964 11.1941 14.2213 10.5034C14.2633 10.3899 14.2183 10.2637 14.1156 10.1991L13.7928 9.99664C13.783 9.98783 13.7722 9.97903 13.7605 9.9712L7.66284 6.15099C7.65207 6.14414 7.64034 6.13925 7.62957 6.13436C7.54838 6.08642 7.44468 6.08349 7.35859 6.13729L2.8164 8.98313C2.74694 8.65932 2.70977 8.32376 2.70977 7.97941C2.70977 5.33412 4.85417 3.18971 7.49946 3.18971C9.90507 3.18971 11.8959 4.96237 12.2373 7.27308C12.249 7.35135 12.2931 7.4208 12.3596 7.46287L14.2712 8.6603C14.4326 8.76204 14.6449 8.66029 14.6566 8.46953C14.6664 8.31398 14.6723 8.15648 14.6723 7.99897C14.6723 4.03886 11.4605 0.828125 7.49946 0.828125Z"
                  fill="#E8F2FF"
                />
              </svg>
            </span>

            <span ref={textRef} className="button-text">Get Early Access</span>

          </button>
        </div>
      </div>
      <div className="lowerbanner" ref={bannerRef}>
        <div ref={videoCardRef} className="bannervideo">
          <video
            className="lowerbannerimg mblorder-1"
            muted="muted"
            playsinline="playsinline"
            autoPlay
            loop
            width="100%"
            id="myVideo"
          >
            <source src="/assets/tomivideo.mp4" type="video/mp4" />
          </video>
          <video
            className="lowerbannerimg mblorder-1 secondvideo"
            muted="muted"
            playsinline="playsinline"
            autoPlay
            loop
            width="100%"
            id="myVideo"
            ref={videoCardRef}
          >
            <source src="/assets/wallet.mp4" type="video/mp4" />
          </video>
        </div>
        <div style={{ position: "relative", width: "100%" }}>
          <div className="lowercard mblorder-2">
            <div className="lowercardhead">
              <h6 className="cardhead">
                Free
                <span className="boldhead"> Yourself</span>
              </h6>
              <div ref={container1}></div>
            </div>

            {/* <p className="cardpara">
            from bouncing between apps - chat and send payments in one place.
          </p> */}
            <Link to="/chatandpay">
              <button className="cardbtn">Dive In</button>
            </Link>
          </div>
          <div className="lowercard mblorder-3">
            <div className="lowercardhead">
              <h6 className="cardhead">
                Free your
                <span className="boldhead"> Money</span>
              </h6>
              <div ref={container2}></div>
            </div>
            {/* <p className="cardpara">
            with an integrated wallet. Now you can instantly view balances,
            access your wallet address, and send and receive tokens across
            multiple blockchains directly within your chats.
          </p> */}
            <Link to="/feature">
              <button className="cardbtn">Explore More Features</button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Mobilebanner;
